import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { PieChartProps } from '../types/chartProps';
import { applyPieChartOptions, renderLabelsForPieChart } from '../utils/pieChartUtils';
import { mergeWithDefaults } from '../utils/chartDefaults';

export const PieChart = React.memo(
  React.forwardRef<HighchartsReact.RefObject, PieChartProps>((props, ref) => {
    const options: Highcharts.Options = applyPieChartOptions(
      mergeWithDefaults({
        chart: {
          type: 'pie',
          marginBottom: 80,
          spacingTop: 10,
          events: {
            render: renderLabelsForPieChart(props)
          }
        }
      }),
      { ...props }
    );

    return <HighchartsReact highcharts={Highcharts} options={options} ref={ref} />;
  })
);
